import {WorkHourCalculatorNormal} from './Strategy/work-hour-calculator-normal';
import {WorkHourCalculatorAbstract} from './Strategy/work-hour-calculator-abstract';
import {WorkHourCalculatorQuick} from './Strategy/work-hour-calculator-quick';
import {WorkHourCalculatorAdvanced} from './Strategy/work-hour-calculator-advanced';
import {WorkHourCalculatorPause} from './Strategy/work-hour-calculator-pause';

export class WorkHourCalculatorFactory {

  public static ENTRY_MODE_NORMAL = 'Normal';
  public static  ENTRY_MODE_ADVANCED = 'Erweitert';
  public static  ENTRY_MODE_QUICK = 'Schnellerfassung';
  public static ENTRY_MODE_PAUSE = 'Pause';

  public static getCalculator(entryMode): WorkHourCalculatorAbstract {
    let calculatorInstance = null;
    switch (entryMode) {
      case WorkHourCalculatorFactory.ENTRY_MODE_NORMAL:
        calculatorInstance = new WorkHourCalculatorNormal();
        break;

      case WorkHourCalculatorFactory.ENTRY_MODE_ADVANCED:
        calculatorInstance = new WorkHourCalculatorAdvanced();
        break;

      case WorkHourCalculatorFactory.ENTRY_MODE_PAUSE:
        calculatorInstance = new WorkHourCalculatorPause();
        break;

      default:
        calculatorInstance = new WorkHourCalculatorQuick();
    }

    return calculatorInstance;
  }
}
